import {Dispatch} from 'redux'
import { resetKsesAction } from "../actions";

export const resetKses = () => (dispatch: Dispatch) => dispatch(resetKsesAction());
